<!--suppress ES6ModulesDependencies, JSUnresolvedVariable -->
<template>
  <div>
    <section class="content-header">
      <h1>
        Vehículos
        <small>Alta de vehículos</small>
      </h1>
    </section>
    <section class="content">

      <div class="container-fluid">
        <!-- basic data vehicle box -->
        <div class="box box-default box-basic-data">
          <!-- .box-header -->
          <div class="box-header with-border">
            <h3 class="box-title">Datos básicos</h3>
          </div>
          <!-- /.box-header -->
          <!-- .box-body -->
          <div class="box-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group" :class="{'has-error':errors.publicationType !== null}">
                  <label>Tipo de Publicación</label>
                  <vue-multiselect
                      v-model="publicationType"
                      label="name"
                      :options="publicationTypes"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                      placeholder="Tipo de publicación"
                      @input="filtersChanged">
                    <span slot="noResult"></span>
                    <span slot="noOptions"></span>
                  </vue-multiselect>
                  <span class="help-block" v-if="errors.publicationType !== null">{{ errors.publicationType }}</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group" :class="{'has-error':errors.dealership !== null}">
                  <label>Concesión</label>
                  <vue-multiselect
                      v-model="dealership"
                      label="name"
                      :options="dealerships"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                      placeholder="Concesionario"
                      @input="dealershipChanged">
                    <span slot="noResult"></span>
                    <span slot="noOptions"></span>
                  </vue-multiselect>
                  <span class="help-block" v-if="errors.dealership !== null">{{ errors.dealership }}</span>
                </div>
              </div>
              <div class="col-md-4" v-if="$store.getters['app/hasRole']('ROLE_ADMIN')">
                <div class="form-group" :class="{'has-error':errors.dealer !== null}">
                  <label>Agente</label>
                  <vue-multiselect
                      v-model="dealer"
                      label="username"
                      :options="dealers"
                      :searchable="true"
                      :loading="dealersLoading"
                      :close-on-select="true"
                      :show-labels="false"
                      placeholder="Agente"
                      @input="filtersChanged">
                    <span slot="noResult"></span>
                    <span slot="noOptions"></span>
                  </vue-multiselect>
                  <span class="help-block" v-if="errors.dealer !== null">{{ errors.dealer }}</span>
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group" :class="{'has-error':errors.maker !== null}">
                  <label>Marca</label>
                  <vue-multiselect
                      v-model="maker"
                      label="name"
                      :options="makers"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                      deselectLabel="quitar"
                      placeholder="Seleccionar marca"
                      @input="onMakerChanged">
                    <span slot="noResult"></span>
                  </vue-multiselect>
                  <span class="help-block" v-if="errors.maker !== null">{{ errors.maker }}</span>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group" :class="{'has-error':errors.model !== null}">
                  <label>Modelo</label>
                  <vue-multiselect
                      v-model="model"
                      label="name"
                      :options="models"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                      placeholder="Seleccionar modelo"
                      @input="onModelChanged">
                    <span slot="noResult"></span>
                    <span slot="noOptions">Selecciona una marca.</span>
                  </vue-multiselect>
                  <span class="help-block" v-if="errors.model !== null">{{ errors.model }}</span>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group" :class="{'has-error':errors.year !== null}">
                  <label>Año de la versión</label>
                  <vue-multiselect
                      v-model="year"
                      label="name"
                      :options="years"
                      :searchable="false"
                      :close-on-select="true"
                      :show-labels="false"
                      :loading="yearsLoading"
                      placeholder="Seleccionar año"
                      @input="onYearChanged">
                    <span slot="noResult"></span>
                    <span slot="noOptions"></span>
                  </vue-multiselect>
                  <span class="help-block" v-if="errors.year !== null">{{ errors.year }}</span>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group" :class="{'has-error':errors.transmission !== null}">
                  <label>Tipo de cambio</label>
                  <vue-multiselect
                      v-model="transmission"
                      label="name"
                      :options="transmissions"
                      :searchable="false"
                      :close-on-select="true"
                      :show-labels="false"
                      placeholder="Seleccionar cambio"
                      @input="filtersChanged">
                  </vue-multiselect>
                  <span class="help-block" v-if="errors.transmission !== null">{{ errors.transmission }}</span>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group" :class="{'has-error':errors.fueltype !== null}">
                  <label>Combustible</label>
                  <vue-multiselect
                      v-model="fuelType"
                      label="name"
                      :options="fuelTypes"
                      :searchable="false"
                      :close-on-select="true"
                      :show-labels="false"
                      :loading="fuelTypesLoading"
                      placeholder="Seleccionar combustible"
                      @input="onFueltypeChange">
                  </vue-multiselect>
                  <span class="help-block" v-if="errors.fueltype !== null">{{ errors.fueltype }}</span>

                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group" :class="{'has-error':errors.version !== null}">
                  <label>Version</label>
                  <vue-multiselect
                      v-model="version"
                      label="name"
                      :options="versions"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                      :loading="versionLoading"
                      placeholder="Seleccionar version"
                      @input="onVersionChanged">
                    <span slot="noResult"></span>
                    <span slot="noOptions"></span>
                  </vue-multiselect>
                  <span class="help-block" v-if="errors.version !== null">{{ errors.version }}</span>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group" :class="{'has-error':errors.versionUnique !== null}">
                  <label>Version Única</label>
                  <vue-multiselect
                      v-model="versionUnique"
                      label="name"
                      :options="versionsUnique"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                      :loading="versionsUniqueLoading"
                      placeholder="Seleccionar version única"
                      @input="loadExtrasByVersionUnique">
                    <span slot="noResult"></span>
                    <span slot="noOptions"></span>
                  </vue-multiselect>
                  <span class="help-block" v-if="errors.versionUnique !== null">{{ errors.versionUnique }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- .box-body -->
          <div class="overlay" v-if="loaders.basicDataEditLoading">
            <i class="fa fa-refresh fa-spin"></i>
          </div>

        </div>
        <!-- /basic data vehicle box -->

        <!-- BOX CHARACTERISTICS -->
        <div class="box box-default box-basic-data">
          <div class="box-header with-border">
            <h3 class="box-title">Ficha</h3>

            <!--<div class="box-tools pull-right">-->
            <!--<button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>-->
            <!--<button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-remove"></i></button>-->
            <!--</div>-->
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="row">

              <div class="col-md-4">
                <div class="form-group" :class="{'has-error':errors.kilometers !== null}">
                  <label>Kilometros reales</label>
                  <div class="input-group">
                    <span class="input-group-addon"><i class="fas fa-tachometer-alt"></i></span>
                    <input type="number" step="5000" v-model="kilometers" class="form-control" placeholder="kilometros reales" @change="filtersChanged">
                  </div>
                  <span class="help-block" v-if="errors.kilometers !== null">{{ errors.kilometers }}</span>
                </div>

              </div>

              <div class="col-md-4">
                <div class="form-group" :class="{'has-error':!plateValidation}">
                  <label>Matrícula</label>
                  <div class="input-group">
                    <span class="input-group-addon"><i class="far fa-address-card"></i></span>
                    <input id="inputError" maxlength="8" type="text" v-model="plate" class="form-control" v-on:keyup="checkPlatePattern" placeholder="Matrícula (ej: 5819 KNF)" pattern="^[0-9]{4} ?[BCDFGHJKLMNPQRSTVWXYZ]{3}" required />
                  </div>
                  <span class="help-block" v-if="!plateValidation">El texto introducido no corresponde con una matrícula válida. (ej: 0000 BBB, 0000BBB)</span>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group" :class="{'has-error': errors.registrationYear != null}">
                  <label>Año de Matriculación</label>
                  <div class="input-group">
                    <span class="input-group-addon"><i class="far fa-calendar"></i></span>
                    <input type="number" :max="currentYear" v-model="registrationYear" placeholder="Año de matriculación" />
                  </div>
                  <span class="help-block" v-if="errors.registrationYear != null">{{errors.registrationYear}}</span>
                </div>
              </div>
              <!--<div class="col-md-4">-->
              <!--<div class="form-group" :class="{'has-error':!errors.plateRegistrationDate}">-->
              <!--<label>Fecha de Matriculación</label>-->

              <!--<div class="input-group date">-->
              <!--<div class="input-group-addon">-->
              <!--<i class="fa fa-calendar"></i>-->
              <!--</div>-->
              <!--<input type="text" class="form-control pull-right datepicker_element">-->
              <!--</div>-->
              <!--&lt;!&ndash;<div class="input-group">&ndash;&gt;-->
              <!--&lt;!&ndash;<span class="input-group-addon"><i class="far fa-address-card"></i></span>&ndash;&gt;-->
              <!--&lt;!&ndash;<input maxlength="8" type="text" v-model="plate" class="form-control" v-on:keyup="checkPlatePattern" placeholder="Matrícula (ej: 5819 KNF)" pattern="^[0-9]{4} ?[BCDFGHJKLMNPQRSTVWXYZ]{3}" required />&ndash;&gt;-->
              <!--&lt;!&ndash;</div>&ndash;&gt;-->
              <!--&lt;!&ndash;<span class="help-block" v-if="!plateValidation">El texto introducido no corresponde con una matrícula válida. (ej: 0000 BBB, 0000BBB)</span>&ndash;&gt;-->
              <!--</div>-->
              <!--</div>-->

              <div class="col-md-4">
                <div class="form-group" :class="{'has-error':!vinValidation}">
                  <label>Número de bastidor</label>
                  <div class="input-group">
                    <span class="input-group-addon"><i class="fas fa-atlas"></i></span>
                    <input type="text" maxlength="17" v-model="vin" class="form-control" @keyup="checkVinPattern" placeholder="Número de bastidor (ej: )" pattern="^[A-Z0-9]{17}$" required />
                  </div>
                  <span class="help-block" v-if="!vinValidation">El texto introducido no corresponde con un número de bastidor válido. (ej: AAA000AAAA000AAA0)</span>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group" :class="{'has-error':errors.color !== null}">
                  <label>Color</label>
                  <vue-multiselect
                      v-model="color"
                      label="name"
                      :options="colors"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                      placeholder="Seleccionar color de carrocería"
                      @input="filtersChanged">
                    <span slot="noResult"></span>
                    <span slot="noOptions"></span>
                  </vue-multiselect>
                  <span class="help-block" v-if="errors.color !== null">{{ errors.color }}</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="colorMetalized">
                      La pintura es metalizada
                    </label>
                  </div>
                </div>
              </div>

            </div> <!-- ROW -->
            <div class="row">
              <div class="col-md-4">
                <div class="form-group" :class="{'has-error': errors.price !== null}">
                  <label>Precio financiado</label>
                  <div class="input-group">
                    <span class="input-group-addon"><i class="fas fa-money-check-alt"></i></span>
                    <input type="number" step="1" class="form-control" min="1000" placeholder="Precio financiado" v-on:keyup="checkPricePattern" @change="filtersChanged" v-model="price">
                  </div>
                  <span class="help-block" v-if="errors.price !== null">{{ errors.price }}</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group" :class="{'has-error': errors.monthlyPrice !== null}">
                  <label>Cuota mensual (opcional)</label>
                  <div class="input-group">
                    <span class="input-group-addon"><i class="fas fa-money-check-alt"></i></span>
                    <input type="number" step="1" class="form-control" min="0" placeholder="Cuota mensual" v-on:keyup="checkMonthlyFinancingPricePattern" @change="filtersChanged" v-model="monthlyPrice">
                  </div>
                  <span class="help-block" v-if="errors.monthlyPrice !== null">{{ errors.monthlyPrice }}</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group" :class="{'has-error': errors.pricePvp !== null}">
                  <label>Precio sin financiar (PVP)</label>
                  <div class="input-group">
                    <span class="input-group-addon">€</span>
                    <input type="number" step="1" class="form-control" min="1000" placeholder="Precio sin financiar (PVP)" v-on:keyup="checkPvPricePattern" @change="filtersChanged" v-model="pricePvp">
                  </div>
                  <span class="help-block" v-if="errors.pricePvp !== null">{{ errors.pricePvp }}</span>
                </div>
              </div>
              <div class="form-group">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="priceTaxIncluded">
                    Los impuestos están incluídos
                  </label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group" :class="{'has-error': errors.warranty !== null}">
                  <label>Garantía</label>
                  <vue-multiselect
                      v-model="warranty"
                      label="name"
                      :options="warranties"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                      placeholder="Seleccionar garantía"
                      @input="filtersChanged">
                    <span slot="noResult"></span>
                    <span slot="noOptions"></span>
                  </vue-multiselect>
                  <span class="help-block" v-if="errors.warranty !== null">{{ errors.warranty }}</span>

                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="warrantyOfficial">
                      La garantía es oficial
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="overlay" v-if="loaders.carTechnicalLoading">
            <i class="fa fa-refresh fa-spin"></i>
          </div>

        </div>
        <!-- /BOX CHARACTERISTICS -->

        <!-- Extras box -->
        <div class="box box-default box-basic-data">
          <!-- .box-header -->
          <div class="box-header with-border">
            <h3 class="box-title">Equipamiento y extras</h3>
          </div>
          <!-- /.box-header -->

          <!-- .box-body -->
          <div class="box-body">
            <div v-if="!extrasLoading && extras.length === 0">
              <small>(Para seleccionar el equipamiento y extras debes seleccionar una versión única válida)</small>
            </div>
            <div class="row" v-if="!extrasLoading && extras.length > 0">
              <div class="col-md-12">
                <!-- Custom Tabs -->
                <div class="nav-tabs-custom">
                  <ul class="nav nav-tabs">
                    <li v-for="(group, index) in extras" :key="group.id" :class="{active: index === 0}">
                      <a v-bind:href="'#tab_' + index" data-toggle="tab">{{group.name}}</a>
                    </li>
                  </ul>
                  <div class="tab-content">

                    <div v-for="(group, index) in extras" :key="'content_' + group.id" class="tab-pane" v-bind:id="'tab_' + index" :class="{active: index === 0}">
                      <div class="row">
                        <div class="col-md-3" v-for="extra in group.extras" :key="'extra_' + extra.id">
                          <div class="form-group">
                            <div class="checkbox">
                              <label>
                                <input type="checkbox" v-model="extra.selected">
                                {{extra.name}}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.tab-pane -->
                  </div>
                  <!-- /.tab-content -->
                </div>
                <!-- nav-tabs-custom -->
              </div>
            </div>
          </div>
          <!-- /.box-body -->

          <div class="overlay" v-if="extrasLoading">
            <i class="fa fa-refresh fa-spin"></i>
          </div>

        </div>

        <!-- Extras box -->
        <div class="box box-default box-basic-data">
          <!-- .box-header -->
          <div class="box-header with-border">
            <h3 class="box-title">Descripción</h3>
          </div>
          <!-- /.box-header -->

          <!-- .box-body -->
          <div class="box-body">
            <div class="row">
              <div class="col-md-12">
                <textarea class="form-control" v-model="description" rows="20" placeholder="Descripción del vehículo"></textarea>
                <!--<vue-html5-editor v-bind:content="description" :height="250" v-on:change="onDescriptionChange"></vue-html5-editor>-->
              </div>

            </div>
          </div>
          <!-- /.box-body -->
        </div>

        <file-picker-component ref="filePickerComponent">
          <div class="has-error"><span class="help-block" v-if="errors.pictures !== null">{{ errors.pictures }}</span></div>
        </file-picker-component>
        <!--<div class="box box-default box-basic-data">-->
        <!--&lt;!&ndash; .box-header &ndash;&gt;-->
        <!--<div class="box-header with-border">-->
        <!--<h3 class="box-title">Fotos del vehículo</h3>-->
        <!--</div>-->
        <!--&lt;!&ndash; /.box-header &ndash;&gt;-->

        <!--&lt;!&ndash; .box-body &ndash;&gt;-->
        <!--<div class="box-body" :class="{'has-error': errors.pictures !== null}">-->
        <!--&lt;!&ndash;<vue-dropzone ref="dropzone"&ndash;&gt;-->
        <!--&lt;!&ndash;id="dropzone"&ndash;&gt;-->
        <!--&lt;!&ndash;:options="dropzoneOptions"&ndash;&gt;-->
        <!--&lt;!&ndash;v-on:vdropzone-file-added="filtersChanged"&ndash;&gt;-->
        <!--&lt;!&ndash;v-on:vdropzone-removed-file="filtersChanged"></vue-dropzone>&ndash;&gt;-->

        <!--<span class="help-block" v-if="errors.pictures !== null">{{ errors.pictures }}</span>-->
        <!--</div>-->
        <!--&lt;!&ndash; /.box-body &ndash;&gt;-->

        <!--<div class="overlay" v-if="loaders.carPicturesLoading">-->
        <!--<i class="fa fa-refresh fa-spin"></i>-->
        <!--</div>-->
        <!--</div>-->
      </div>

      <div class="container container_btn_save">

        <div class="alert alert-danger" v-if="showErrorFlashInBtnSave">
          El formulario tiene errores que deben ser corregídos antes de continuar
        </div>

        <button class="btn btn-primary btn_save" @click="clickSaveBtn">{{ editCarData !== null ? 'GUARDAR CAMBIOS' : 'CREAR VEHICULO' }}</button>
      </div>
      <!--<button type="button" class="btn btn-default" data-toggle="modal" data-target="#modal-default"></button>-->
      <div class="modal fade" id="modal-saving">
        <div class="modal-dialog">
          <div class="modal-content" style="text-align: center">
            <div class="modal-header">
              <b>{{ editCarData !== null ? 'Guardando cambios del vehículo…' : 'Creando vehículo…' }}</b> <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="modal-body">
              <div class="progress">
                <div class="progress-bar progress-bar-aqua" v-bind:style="{width: uploadProgress + '%'}" role="progressbar" aria-valuemax="100">
                </div>
              </div>

              {{ editCarData !== null ? '' : 'La espera del proceso depende de la cantidad y tamaño de las fotografías' }}
            </div>
            <div class="modal-footer">

            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->

      <div class="modal fade" id="modal-error">
        <div class="modal-dialog">
          <div class="modal-content" style="text-align: center">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span></button>
            </div>

            <div class="modal-body">
              <div class="error-content">
                <h3><i class="fa fa-warning text-red"></i> Oops! algo ha salido mal.</h3>

                <p>
                  Ha ocurrido un problema guardando el vehículo, íntentalo de nuevo más tarde, si el problema continúa, ponte en contacto con soporte técnico.
                </p>
                <small>{{ networkError }}</small>
              </div>

            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Cancelar</button>
              <button type="button" class="btn btn-primary" @click.prevent="clickSaveBtn">Volver a intentar</button>
            </div>

          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->

    </section>

  </div>
</template>

<script>
import vueMultiselect from 'vue-multiselect'
import util from '../../utils/util'
import webservice from '../../utils/webservice'
import axios from 'axios'
// import vueDropzone from 'vue2-dropzone'
import {logger} from '@/utils/Logger'
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min'
import FilePickerComponent from '@/components/custom/FilePickerComponent'
// import Queue from 'promise-queue'
// import VaButton from 'vue2-admin-lte/src/components/VAButton'

import moment from 'moment'

export default {
  name: 'PageCreateCarComponent',
  // components: { vueMultiselect, vueDropzone },
  components: { vueMultiselect, FilePickerComponent },

  data () {
    return {

      editCarData: null,

      errors: {
        publicationType: null,
        maker: null,
        model: null,
        year: null,
        transmission: null,
        fueltype: null,
        version: null,
        versionUnique: null,
        kilometers: null,
        plate: null,
        plateRegistrationDate: null,
        vin: null,
        color: null,
        price: null,
        pricePvp: null,
        warranty: null,
        description: null,
        pictures: null,
        dealership: null,
        dealer: null,
        registrationYear: null,
        monthlyPrice: null
      },

      networkError: null,

      showErrorFlashInBtnSave: false,

      carDataIsValid: false,

      loaders: {
        basicDataEditLoading: false,
        carTechnicalLoading: false,
        carPicturesLoading: false,
        sendingCarData: true
      },

      // dropzoneOptions: {
      //   url: function () {
      //     return 'http://localhost'
      //   },
      //   thumbnailWidth: 200,
      //   thumbnailHeight: 200,
      //   addRemoveLinks: true,
      //   maxFiles: 200,
      //   // maxFilesize: null,
      //   duplicateCheck: false,
      //
      //   dictRemoveFile: 'Eliminar fotografía',
      //   dictDefaultMessage: 'Arrastra y suelta aquí o haz click para seleccionar las fotos del vehículo, la primera foto que subas será la foto portada.',
      //   dictCancelUpload: 'Cancelar subida',
      //   dictUploadCanceled: 'Subida cancelada',
      //   dictCancelUploadConfirmation: '¿Estas seguro de querer cancelar la subida del fichero?',
      //   dictRemoveFileConfirmation: '¿Seguro que quieres quitar esta foto?',
      //   resizeQuality: 0.8,
      //   resizeWidth: 900,
      //   resizeMimeType: 'image/jpeg',
      //   autoProcessQueue: false
      // },

      maker: null,
      makers: util.makers,

      model: null,
      models: [],

      publicationType: null,
      publicationTypes: util.carTypes,

      dealer: null,
      dealers: [],
      dealership: null,
      dealerships: [],
      dealersLoading: false,

      year: null,
      yearsLoading: false,
      years: [],

      version: null,
      versionLoading: false,
      versions: [],

      fuelType: null,
      fuelTypesLoading: false,
      fuelTypes: util.fuelTypes,

      transmission: null,
      transmissions: util.transmissions,

      versionUnique: null,
      versionsUniqueLoading: false,
      versionsUnique: [],

      kilometers: 0,
      plate: '',
      plateValidation: true,
      vin: '',
      vinValidation: true,

      registrationYear: null,
      currentYear: parseInt(moment().format('YYYY')),

      color: null,
      colors: util.colors,
      colorMetalized: false,

      price: null,
      priceValidation: true,

      monthlyPrice: null,
      monthlyPriceValidation: true,

      pricePvp: null,
      pricePvpValidation: true,

      priceTaxIncluded: true,

      warranty: null,
      warranties: [
        { name: 'Sin garantía', id: 0 },
        { name: '12 meses (1 año)', id: 12 },
        { name: '18 meses (1 año y medio)', id: 18 },
        { name: '24 meses (2 años)', id: 24 },
        { name: '36 meses (3 años)', id: 36 },
        { name: '48 meses (4 años)', id: 48 },
        { name: '60 meses (5 años)', id: 60 },
        { name: '72 meses (6 años)', id: 72 },
        { name: '84 meses (7 año o más)', id: 84 }
      ],
      warrantyOfficial: false,

      extras: [],
      extrasLoading: false,

      description: '',

      uploadProgress: 0
    }
  },

  mounted () {
    if (this.$route.name === 'edit_car') {
      this.loaders.basicDataEditLoading = true
      let showRequestStartTime = new Date().getTime()
      axios.get(`${process.env.API_ENDPOINT}/car/${this.$route.params.carCode}/show`).then(({ data }) => {
        logger.info(`Retrieved show info in ${new Date().getTime() - showRequestStartTime} ms`)
        this.setupCarData(data)
      })
    } else {
      webservice.dealer.findDealerships().then(dealerships => {
        this.dealerships = dealerships
        let dealerId = this.$store.state.app.session.payload.dealer.id
        let dealershipId = this.$store.state.app.session.payload.dealership.id
        this.dealership = this.dealerships.find(dealership => dealershipId === dealership.id)

        this.loadDealersByDealership(this.dealership.id).then(dealers => {
          this.dealers = dealers
          this.dealer = dealers.find(({id}) => id === dealerId)
        })
      })
    }

    window.$('.datepicker_element').datepicker({
      autoclose: true
    })
  },

  methods: {

    onDescriptionChange (textChange) {
      this.description = textChange
    },

    displaySavingModal (show) {
      if (show) {
        window.$('#modal-saving').modal({
          backdrop: 'static',
          keyboard: false
        })
      } else {
        window.$('#modal-saving').modal('hide')
      }
    },

    setupCarData (carData) {
      document.title = `${carData.fullText} (v${process.env.VERSION})`
      this.editCarData = carData
      this.loadCarPictures(carData)
      let loadCarBasicDataStartTime = new Date().getTime()
      this.loadCarBasicData(carData).then(() => {
        logger.info(`loadCarBasicdata in ${new Date().getTime() - loadCarBasicDataStartTime} ms`)
        this.loaders.basicDataEditLoading = false
      })
      this.loaders.carTechnicalLoading = true
      let loadCarTechnicalStartTime = new Date().getTime()
      this.loadCarTechnical(carData).then(() => {
        logger.info(`loadCarTechnical in ${new Date().getTime() - loadCarTechnicalStartTime} ms`)
        this.loaders.carTechnicalLoading = false
      })
    },

    filtersChanged () {
      this.carDataIsValid = this.validateData(false)
      this.showErrorFlashInBtnSave = false
    },

    clickSaveBtn () {
      window.$('#modal-saving').modal('hide')
      window.$('#modal-error').modal('hide')
      this.carDataIsValid = this.validateData(true)

      logger.info('Clicked save button')
      if (!this.carDataIsValid) {
        logger.info('Invalid car data')
        this.showErrorFlashInBtnSave = true
      } else {
        if (this.editCarData !== null) {
          logger.info('correct car data, saving…')
          this.saveCarByEdit()
        } else {
          logger.info('correct car data, creating…')
          this.createCar()
        }
      }
    },

    getCarData () {
      let selectedExtras = []
      this.extras.forEach(({extras}) => extras.map(extra => {
        extra.selected = extra.hasOwnProperty('selected') && extra.selected
        return extra
      }).filter(({selected}) => selected).map(extra => selectedExtras.push(extra.id)))

      let dealerId = this.$store.state.app.session.payload.dealer.id
      let dealershipId = this.$store.state.app.session.payload.dealership.id

      if (this.dealer !== null) {
        dealerId = this.dealer.id
      }
      if (this.dealership !== null) {
        dealershipId = this.dealership.id
      }

      return {
        code: this.editCarData !== null ? this.editCarData.code : null,
        versionUniqueId: this.versionUnique.id,
        transmissionId: this.transmission.id,
        colorId: this.color.id,
        kilometers: this.kilometers,
        vehicleRegistration: this.plate,
        vin: this.vin,
        colorIsMetallized: this.colorMetalized,
        price: this.price,
        financiationMonthlyQuote: this.monthlyPrice,
        price_pvp: this.pricePvp,
        priceTaxIncluded: this.priceTaxIncluded,
        warranty: this.warranty.id,
        warrantyOfficial: this.warrantyOfficial,
        infoAdditional: this.description,
        dealerId: dealerId,
        dealershipId: dealershipId,
        carType: this.publicationType.id,
        advertisers: JSON.stringify([3]),
        year: this.registrationYear,
        source: 'multipublicador',
        extras: selectedExtras
      }
    },

    saveCarByEdit () {
      this.displaySavingModal(true)
      let {pictures, picturesMetadata} = this.$refs.filePickerComponent.getPictures()
      let originalIds = this.editCarData.pictures.map(picture => picture.id)
      let actualIds = picturesMetadata.map(picture => picture.id).filter(picture => picture !== null)

      let carData = this.getCarData()
      carData.removePictures = originalIds.filter(originalId => actualIds.indexOf(originalId) < 0)

      carData.pictures = pictures.map((picture, index) => {
        let metadata = picturesMetadata[index]
        if (metadata.hasOwnProperty('originalPosition') && metadata.originalPosition !== undefined && metadata.originalPosition !== null) {
          return new File([], `${index}`, {type: 'text/plain'})
        } else {
          return picture
        }
      })
      // carData.pictures = pictures.filter((picture, index) => {
      //   let metadata = picturesMetadata[index]
      //   return index === 0 || metadata.position !== metadata.originalPosition
      // })
      // carData.picturesMetadata = JSON.stringify(picturesMetadata.filter((metadata, index) => index === 0 || metadata.position !== metadata.originalPosition))
      carData.picturesMetadata = JSON.stringify(picturesMetadata)

      // console.log({pictures: carData.pictures, metadata: carData.picturesMetadata})

      let elapsedTime = new Date().getTime()
      webservice.putCar(carData, progress => {
        this.uploadProgress = progress
      }).then(response => {
        if (response !== null && response !== '' && (response.indexOf('{') > -1 || response.indexOf('[') > -1)) {
          let responseData = JSON.parse(response)
          if (responseData.hasOwnProperty('code')) {
            // this.setupCarData(responseData)
            this.displaySavingModal(false)
            logger.info('car saved succesful in ' + (new Date().getTime() - elapsedTime) + 'ms')
            setTimeout((self) => {
              self.$router.push({name: 'search_cars'})
            }, 500, this)
          } else {
            throw new Error(`unexpected response ${response}`)
          }
          this.displaySavingModal(false)
        } else {
          throw new Error(`unexpected response ${response}`)
        }
      }).catch(error => {
        logger.error(error)
        window.$('#modal-saving').modal('hide')
        this.displaySavingModal(false)
        setTimeout((context) => {
          if (error instanceof Error) {
            context.networkError = `${error.message}\n${error.stack}`
          } else {
            try {
              context.networkError = JSON.stringify(error)
            } catch (exception) {
              context.networkError = 'Unknown'
            }
          }
          window.$('#modal-error').modal('show')
        }, 500, this)
      })
    },

    createCar () {
      let carData = this.getCarData()
      let { pictures, picturesMetadata } = this.$refs.filePickerComponent.getPictures()
      carData.pictures = pictures
      carData.picturesMetadata = JSON.stringify(picturesMetadata)

      this.displaySavingModal(true)
      logger.info('posting car data ')
      let elapsedTime = new Date().getTime()
      webservice.postCar(carData, uploadProgress => {
        this.uploadProgress = uploadProgress
      }).then(() => {
        this.displaySavingModal(false)
        logger.info('car created succesful in ' + (new Date().getTime() - elapsedTime) + 'ms')
        setTimeout((self) => {
          self.$router.push({name: 'search_cars'})
        }, 500, this)
      }).catch(error => {
        logger.error(error)
        window.$('#modal-saving').modal('hide')

        setTimeout((context) => {
          if (error instanceof Error) {
            context.networkError = `${error.message}\n${error.stack}`
          } else {
            try {
              context.networkError = JSON.stringify(error)
            } catch (exception) {
              context.networkError = 'Unknown'
            }
          }
          window.$('#modal-error').modal('show')
        }, 500, this)
      })
    },

    validateData (showErrors) {
      // Reset validations
      for (let k in this.errors) {
        if (this.errors.hasOwnProperty(k)) {
          this.errors[k] = null
        }
      }

      // Validation
      if (this.publicationType === null) {
        if (showErrors) {
          this.errors.publicationType = 'El tipo de publicación no puede estar vacío'
        }
        return false
      }

      if (this.maker === null) {
        if (showErrors) {
          this.errors.maker = 'La marca no puede estar vacía.'
        }
        return false
      }

      if (this.model === null) {
        if (showErrors) {
          this.errors.model = 'El modelo no puede estar vacío.'
        }
        return false
      }

      if (this.year === null) {
        if (showErrors) {
          this.errors.year = 'El año de matriculación no puede estar vacío.'
        }
        return false
      }

      if (this.transmission === null) {
        if (showErrors) {
          this.errors.transmission = 'El tipo de cambio no puede estar vacío.'
        }
        return false
      }

      if (this.fueltype === null) {
        if (showErrors) {
          this.erros.fuelType = 'El tipo de combustible no puede estar vacío'
        }
        return false
      }

      if (this.version === null) {
        if (showErrors) {
          this.errors.version = 'La versión no puede estar vacía'
        }
        return false
      }

      if (this.versionUnique === null) {
        if (showErrors) {
          this.errors.versionUnique = 'La versión única no puede estar vacía'
        }
        return false
      }

      if (this.kilometers === null || this.kilometers === '' || this.kilometers < 0) {
        if (showErrors) {
          this.errors.kilometers = 'Introduce la cantidad de kilometros reales (0 si es nuevo)'
        }
        return false
      }

      if (this.registrationYear === null || this.registrationYear > this.currentYear || this.registrationYear < 2000) {
        if (showErrors) {
          if (this.registrationYear === null) {
            this.errors.registrationYear = 'El año de matriculación no puede estar vacío'
          } else {
            if (this.registrationYear > this.currentYear) {
              this.errors.registrationYear = 'El año de matriculación no puede ser superior al año actual!'
            } else {
              this.errors.registrationYear = `El año de matriculación debe estar entre 2000 y ${this.currentYear}`
            }
          }
        }
        return false
      }

      if (this.color === null) {
        if (showErrors) {
          this.errors.color = 'El color del vehículo no puede estar vacío'
        }
        return false
      }

      if (this.price === null || this.price === '' || this.price < 1000) {
        if (showErrors) {
          this.errors.price = 'El precio del vehículo no puede ser inferior a 1000€'
        }
        return false
      }

      if ((this.pricePvp !== null && this.pricePvp !== '') && this.pricePvp < 1000) {
        if (showErrors) {
          this.errors.pricePvp = 'El precio PVP del vehículo no puede ser inferior a 1000€'
        }
        return false
      }

      if (this.warranty === null) {
        if (showErrors) {
          this.errors.warranty = 'Debes seleccionar la garantía (exista la opción "Sin garantía")'
        }
        return false
      }

      // window.dropzone = this.$refs.dropzone
      if (this.$refs.filePickerComponent.getPictures().pictures.length < 1) {
        if (showErrors) {
          this.errors.pictures = 'El vehículo debe contener al menos una fotografía'
        }
        return false
      }

      if (this.$store.getters['app/hasRole']('ROLE_ADMIN')) {
        if (this.dealer === null) {
          if (showErrors) {
            this.errors.dealer = 'El agente asociado a este vehiculo no puede estar vacío'
          }
          return false
        }

        if (this.dealership === null) {
          if (showErrors) {
            this.errors.dealership = 'El concesionario no puede estar vacío'
          }
          return false
        }
      }
      return true
    },

    loadCarBasicData (data) {
      return new Promise((resolve, reject) => {
        this.publicationType = this.publicationTypes.find(({id}) => id === data.type.id)
        this.maker = this.makers.find(({id}) => id === data.version.maker.id)
        this.onMakerChanged()
        this.model = this.maker.models.find(({id}) => id === data.version.model.id)
        this.transmission = this.transmissions.find(({id}) => id === data.transmission.id)
        this.registrationYear = data.year

        let findDealershipsStartTime = new Date().getTime()
        webservice.dealer.findDealerships().then(dealerships => {
          this.dealerships = dealerships
          this.dealership = this.dealerships.find(({id}) => id === data.dealership.id)
          if (this.$store.getters['app/hasRole']('ROLE_ADMIN')) {
            this.dealer = null
            this.dealers = []
            this.loadDealersByDealership(this.dealership.id).then(dealers => {
              this.dealers = dealers
              this.dealer = dealers.find(({id}) => id === data.dealer.id)
            })
          }
          logger.info(`webservice.dealer.findDealerships in ${new Date().getTime() - findDealershipsStartTime}ms`)
        })

        webservice.fixtures.provideFromVersionUniqueId(data.versionUnique.id).then(fixtures => {
          this.years = fixtures.years
          this.year = this.years.find(({id}) => id === data.versionUnique.year)

          this.fuelTypes = fixtures.fuelTypes
          this.fuelType = this.fuelTypes.find(({id}) => id === data.version.fueltype.id)

          this.versions = fixtures.versions
          this.version = this.versions.find(({id}) => id === data.version.id)

          this.versionsUnique = fixtures.versionsUnique
          this.versionUnique = this.versionsUnique.find(({id}) => id === data.versionUnique.id)

          console.log('Extras', JSON.stringify(data.extras))
          console.log('Fixtures extras', JSON.stringify(fixtures.extras))

          data.extras.forEach(extra => {
            let group = fixtures.extras.find(({id}) => id === extra.group.id)
            let groupExtra = group.extras.find(({id}) => id === extra.id)

            if (groupExtra === undefined) {
              console.log({extra, group, groupExtra})
            }
            // noinspection JSValidateTypes
            if (groupExtra !== null && groupExtra !== undefined) {
              // noinspection JSUndefinedPropertyAssignment
              groupExtra.selected = true
            }
          })
          this.extras = fixtures.extras
          this.filtersChanged()

          resolve()
        })
      })
    },

    loadCarTechnical (data) {
      // noinspection JSUnusedLocalSymbols
      return new Promise((resolve, reject) => {
        this.kilometers = data.kilometers
        this.plate = data.plate.replace('-', ' ').trim()
        this.vin = data.vin.trim()
        this.color = this.colors.find(({id}) => id === data.color.id)
        // noinspection JSUnresolvedVariable
        this.colorMetalized = data.colorIsMetalized
        this.price = data.price
        this.monthlyPrice = data.financiationMonthlyQuoteIsAutoCalculated ? '' : data.financiationMonthlyQuote
        this.pricePvp = data.pricePvp
        this.priceTaxIncluded = data.priceTaxIncluded
        this.warranty = this.warranties.find(({id}) => id === data.warranty)
        // noinspection JSUnresolvedVariable
        this.warrantyOfficial = data.warrantyIsOfficial

        let strip = html => {
          let tmp = document.createElement('div')
          tmp.innerHTML = html
          return tmp.textContent || tmp.innerText || ''
        }

        this.description = strip(data.description)
        resolve()
      })
    },

    loadCarPictures (data) {
      this.$refs.filePickerComponent.setPictures(data.pictures)
    },

    onMakerChanged () {
      if (this.maker != null && this.maker.id > 0) {
        this.models = util.modelsByMaker(this.maker.id)
      } else {
        this.models = []
        this.year = null
        this.fuelType = null
        this.version = null
        this.versionUnique = null
      }
      this.model = null
      this.filtersChanged()
    },
    onModelChanged () {
      this.year = null
      this.years = []
      this.fuelType = null
      this.fuelTypes = []
      this.version = null
      this.versions = []
      this.versionUnique = null

      if (this.maker !== null && this.model !== null) {
        this.loadYearsByMakerAndModel(this.maker.id, this.model.id).then(() => {
          this.filtersChanged()
        })
      } else {
        this.filtersChanged()
      }
    },
    onYearChanged () {
      this.fuelType = null
      this.fuelTypes = []
      this.version = null
      this.versions = []
      this.versionUnique = null
      if (this.maker !== null && this.model !== null && this.year !== null) {
        this.loadFueltypesFromMakerAndModelAndYear(this.maker.id, this.model.id, this.year.id).then(() => {
          this.filtersChanged()
        })
      } else {
        this.filtersChanged()
      }
    },
    onFueltypeChange () {
      this.version = null
      this.versions = []
      if (this.maker !== null && this.model !== null && this.year !== null && this.fuelType !== null) {
        this.loadVersionsByMakerAndModelAndYearAndFueltype(this.maker.id, this.model.id, this.year.id, this.fuelType.id).then(() => {
          this.filtersChanged()
        })
      } else {
        this.filtersChanged()
      }
    },
    onVersionChanged () {
      this.versionUnique = null
      this.versionsUnique = []
      if (this.version !== null && this.year !== null) {
        this.loadUniqueVersionsByVersion(this.version.id, this.year.id).then(() => {
          this.filtersChanged()
        })
      } else {
        this.filtersChanged()
      }
    },

    dealershipChanged () {
      this.dealersLoading = true
      this.dealers = []
      this.dealer = null
      this.loadDealersByDealership(this.dealership.id).then((dealers) => {
        this.dealers = dealers
        this.dealersLoading = false
        this.filtersChanged()
      })
    },

    loadFueltypesFromMakerAndModelAndYear (makerId, modelId, year) {
      return new Promise((resolve, reject) => {
        this.fuelTypesLoading = true
        webservice.versions.loadFueltypesFromMakerAndModelAndYear(makerId, modelId, year).then(fuelTypes => {
          this.fuelTypes = fuelTypes
          this.fuelTypesLoading = false
          resolve(fuelTypes)
        }).catch(reject)
      })
    },
    loadYearsByMakerAndModel (makerId, modelId) {
      return new Promise((resolve, reject) => {
        this.yearsLoading = true
        axios.post(`${process.env.API_ENDPOINT}/version/findYearsByMakerAndModel`, {makerId, modelId}).then(response => {
          this.yearsLoading = false
          this.years = response.data
          resolve(response.data)
        }).catch(reject)
      })
    },
    loadVersionsByMakerAndModelAndYearAndFueltype (makerId, modelId, year, fuelTypeId) {
      return new Promise((resolve, reject) => {
        this.versionLoading = true
        axios.post(`${process.env.API_ENDPOINT}/version/findByMakerAndModelAndYearAndFueltype`, {makerId, modelId, year, fuelTypeId}).then(response => {
          this.versions = response.data
          this.versionLoading = false
          resolve(this.versions)
        }).catch(reject)
      })
    },
    loadUniqueVersionsByVersion (versionId) {
      return new Promise((resolve, reject) => {
        this.versionsUniqueLoading = true
        webservice.versions.findUniqueVersionsByVersionAndYear(versionId).then(versionsUnique => {
          this.versionsUnique = versionsUnique
          this.versionsUniqueLoading = false
          resolve(this.versionsUnique)
        }).catch(reject)
      })
    },
    loadExtrasByVersionUnique () {
      return new Promise((resolve, reject) => {
        this.extras = []
        if (this.versionUnique === null) {
          return
        }
        this.extrasLoading = true
        webservice.extras.findExtrasByVersionUniqueIdGrouped(this.versionUnique.id).then(extrasGroups => {
          this.extras = extrasGroups.map(extrasGroup => {
            extrasGroup.extras.map(extra => {
              extra.selected = false
              return extra
            })
            return extrasGroup
          })
          this.extrasLoading = false
          resolve(this.extras)
        }).catch(reject)

        webservice.extras.findCharacteristicsByVersionUniqueId(this.versionUnique.id) // async task
      })
    },
    loadDealersByDealership: dealershipId => new Promise((resolve, reject) => {
      webservice.dealer.findByDealershipId(dealershipId).then(dealers => {
        this.dealers = dealers
        resolve(this.dealers)
      }).catch(reject)
    }),
    checkPlatePattern () {
      this.plate = this.plate.toUpperCase().trim()
      this.plateValidation = this.plate === '' || (this.plate.match(/^[0-9]{4} ?[BCDFGHJKLMNPQRSTVWXYZ]{3}/) !== null)
      if ((this.plateValidation && this.plate !== '') && this.plate.indexOf(' ') === -1) {
        this.plate = this.plate.substring(0, 4) + ' ' + this.plate.substring(4, 7)
      }
      this.filtersChanged()
    },
    checkVinPattern () {
      this.vin = this.vin.toUpperCase().trim()
      this.vinValidation = this.vin === '' || (this.vin.match(/^[0-9A-Z]{17}/))
      this.filtersChanged()
    },
    checkPricePattern () {
      this.price = this.price.trim().replace(' ', '').replace('€', '').replace('.', '').replace(',', '')
      if (this.price < 0) {
        this.price = null
      } else {
        if (this.price >= 1000) {
          this.errors.price = null
        }
      }
    },
    checkMonthlyFinancingPricePattern () {
      this.monthlyPrice = parseInt(this.monthlyPrice.trim().replace(' ', '').replace('€', '').replace('.', '').replace(',', ''))
      if (this.monthlyPrice < 0) {
        this.monthlyPrice = null
      } else {
        if (parseInt(this.monthlyPrice, 10) === 0) {
          this.errors.price = null
        }
      }
    },
    checkPvPricePattern () {
      this.pricePvp = this.pricePvp.trim().replace(' ', '').replace('€', '').replace('.', '').replace(',', '')
      if (this.pricePvp < 0) {
        this.pricePvp = null
      } else {
        if (this.pricePvp >= 1000) {
          this.errors.pricePvp = null
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import 'vue-multiselect/dist/vue-multiselect.min.css';
  /*@import 'vue2-dropzone/dist/vue2Dropzone.min.css';*/
  @import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';

  /*.dropzone {*/
  /*.dz-preview {*/
  /*.dz-progress {*/
  /*display: none !important;*/
  /*}*/
  /*.dz-details {*/
  /*background-color: rgba(33,150,243,0.4);*/
  /*}*/
  /*}*/
  /*}*/

  .multiselect--active {
    z-index: 9999;
  }
  .multiselect__content-wrapper {
    z-index: 4;
  }
  .multiselect__element {
    z-index: 4;
  }

</style>

<style lang="scss" scoped>
  .multiselect, .input-group {
    /*max-width: 350px;*/
  }
  /*.multiselect {*/
  /*z-index: 4;*/
  /*}*/
  input[type="checkbox"] {
    z-index: 0 !important;
  }
  .multiselect {
    .multiselect__single {
      font-size: 14px !important;
    }
  }

  .input-group-addon {
    border-top-left-radius: 5px !important;
    border-bottom-left-radius: 5px !important;
  }

  input {
    min-height: 40px;
    display: block;
    padding: 8px 40px 8px 8px;
    border-radius: 5px;
    border: 1px solid #e8e8e8;
    background: #fff;
    font-size: 1.0em;
    z-index:1 !important;
  }

  .checkbox {
    padding-top:22px;
    font-size: 1.2em;
  }

  .box-basic-data {
    margin-top: 20px;
  }

  .btn_save {
    max-width: 200px;
    margin: 0 auto;
  }

  .has-error {
    .help-block {
      position: absolute;
      margin-top: -1px;
      background-color: #dd4b39e3;
      color: white !important;
      border: 1px solid #4444;
      z-index: 999;
      padding: 10px;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }

  .container_btn_save {
    text-align : center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/PageCreateCarComponent.vue